/**
Author - Venkatesh 😁
Git - https://github.com/venkatesh1146
**/

import React, {useEffect, useState} from 'react';

import styled from 'styled-components';

import PopupModal from 'components/Popup';
import MuiForm from 'components/MuiForm';

import {ActionButton} from 'screens/commons';

const FATCAForm = ({formSchema, handleFormSubmit}) => {
  const [showSupportPopup, setShowSupportPopup] = useState(false);
  useEffect(() => {
    const stepperContainer = document.querySelector('[class*="meta-form-stepper"]');
    if (!!stepperContainer) {
      stepperContainer.classList.add('stepper');
    }
  }, []);

  return (
    <Container>
      <FormWrapper>
        <MuiForm
          schema={formSchema?.schema}
          onSubmit={(data) => {
            const isFatcaNotApplicable = data?.fatca_applicable === 'N';
            if (isFatcaNotApplicable) {
              const sanitized = Object.fromEntries(
                Object.entries(data).map(([key, value]) => {
                  const shouldClear = key.startsWith('fatca') && key !== 'fatca_applicable';
                  return [key, shouldClear ? '' : value];
                })
              );
              return handleFormSubmit(sanitized);
            }

            if (['US', 'CA'].includes(data.fatca_citizenship)) {
              return setShowSupportPopup(true);
            }

            handleFormSubmit(data);
          }}
          buttons={{
            submit: <ActionButton buttonText="Continue" />,
          }}
        />
      </FormWrapper>

      <PopupModal
        close={() => setShowSupportPopup(false)}
        shouldShow={showSupportPopup}
        showSupportLinks
        modalHeader={<Heading className="body-large">Important Notice !</Heading>}
      >
        <Message className="body-small">
          Due to regulatory requirements, we currently do not support online account creation for US
          and Canadian tax residents. Please contact your Wealthy partner who can assist you with
          the offline account opening process
        </Message>
      </PopupModal>
    </Container>
  );
};

const Heading = styled.h3`
  margin: 0 0 16px 0;
`;

const Message = styled.p`
  margin: 0 0 16px 0;
`;

const Container = styled.div`
  height: 100%;
  width: 100%;
  scroll-behavior: scroll;
  position: relative;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  padding-bottom: 2rem;

  @media (max-width: 768px) {
    background: white;
  }
`;

const FormWrapper = styled.div`
  flex-grow: 1;
  padding: 1rem;
  @media (min-width: 768px) {
    padding: 3rem;
  }
`;

export default FATCAForm;
